import React from 'react';
import { useSelector } from 'react-redux';
import errImage from '../assets/images/error.svg';
import Content from './Content.js';
import ErrorBoundary from './ErrorBoundary.js';
import PageBase from './PageBase.js';
import TopNav from './TopNav/index.js';
export const ErrorPage = () => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(React.Fragment, null,
        React.createElement(TopNav, null),
        React.createElement(Content, null,
            React.createElement(PageBase, null,
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: 'calc(100vh - 120px)',
                    } },
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%',
                            maxWidth: '600px',
                        } },
                        React.createElement("img", { style: { maxWidth: '100%' }, src: errImage }),
                        React.createElement("h1", { style: {} }, lang.misc.errorOccured)))))));
};
const CHUNK_RELOAD_KEY = 'chunk-load-error-reload';
// Deploys are atomic, so content-hashed chunks referenced by an already-open
// tab disappear. A full reload fetches the new index.html and chunk set.
const isChunkLoadError = (err) => {
    if (err == null) {
        return false;
    }
    if (err.name === 'ChunkLoadError') {
        return true;
    }
    const message = typeof err.message === 'string' ? err.message : '';
    return /Loading chunk .+ failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i.test(message);
};
// Guarded per-URL via sessionStorage so a genuinely broken chunk surfaces the
// error page instead of an infinite reload loop.
const reloadOnceForChunkError = () => {
    try {
        if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === window.location.href) {
            return false;
        }
        sessionStorage.setItem(CHUNK_RELOAD_KEY, window.location.href);
    }
    catch {
        return false;
    }
    window.location.reload();
    return true;
};
const clearChunkReloadMarker = () => {
    try {
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    }
    catch {
        // sessionStorage unavailable; nothing to clear
    }
};
export const AsyncComponent = (Loader, Error, fetcher, reportError) => class AsyncComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            success: false,
            component: undefined,
            error: undefined,
        };
    }
    UNSAFE_componentWillMount() {
        fetcher()
            .then((component) => {
            clearChunkReloadMarker();
            this.setState({
                loading: false,
                success: true,
                component,
            });
        })
            .catch((err) => {
            if (isChunkLoadError(err) && reloadOnceForChunkError()) {
                return;
            }
            this.setState({
                loading: false,
                error: err,
            });
        });
    }
    render() {
        return (React.createElement(ErrorBoundary, { fallback: React.createElement(ErrorPage, null), reportError: reportError }, this.state.loading
            ? React.createElement(Loader)
            : this.state.success
                ? React.createElement(this.state.component, this.props)
                : React.createElement(Error, { error: this.state.error })));
    }
};
export default AsyncComponent;
//# sourceMappingURL=AsyncComponent.js.map